import {
  FETCH_CONTAINER_YARDS,
  FETCH_CONTAINER_YARDS_SUCCESS,
  FETCH_CONTAINER_YARDS_FAILED,
  EDIT_CONTAINER_YARD
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, push, set, remove } from "firebase/database";

const optionalNumber = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? "" : parsed;
};

const buildContainerYardPayload = (yard) => {
  const availableSlots = yard.availableSlots !== undefined ? parseInt(yard.availableSlots) : 0;
  const totalSlots = yard.totalSlots !== undefined ? parseInt(yard.totalSlots) : availableSlots;
  return {
    name: yard.name,
    shippingLineName: yard.shippingLineName || "",
    region: yard.region || "",
    location: yard.location || "",
    availableSlots: isNaN(availableSlots) ? 0 : availableSlots,
    totalSlots: isNaN(totalSlots) ? 0 : totalSlots,
    latitude: optionalNumber(yard.latitude),
    longitude: optionalNumber(yard.longitude),
    geofenceRadiusMeters: optionalNumber(yard.geofenceRadiusMeters),
    active: yard.active !== false
  };
};

export const fetchContainerYards = () => (dispatch) => {
  const { containerYardsRef } = firebase;

  dispatch({
    type: FETCH_CONTAINER_YARDS,
    payload: null,
  });

  onValue(containerYardsRef, (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const yards = Object.keys(data).map((id) => {
        const availableSlots = data[id].availableSlots !== undefined ? parseInt(data[id].availableSlots) : 0;
        const totalSlots = data[id].totalSlots !== undefined ? parseInt(data[id].totalSlots) : availableSlots;
        return {
          id,
          ...data[id],
          shippingLineName: data[id].shippingLineName || "",
          region: data[id].region || "",
          availableSlots: isNaN(availableSlots) ? 0 : availableSlots,
          totalSlots: isNaN(totalSlots) ? 0 : totalSlots
        };
      });
      dispatch({
        type: FETCH_CONTAINER_YARDS_SUCCESS,
        payload: yards
      });
    } else {
      dispatch({
        type: FETCH_CONTAINER_YARDS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_container_yards || "No container yards available.",
      });
    }
  }, (error) => {
    dispatch({
      type: FETCH_CONTAINER_YARDS_FAILED,
      payload: error && error.message ? error.message : "Unable to fetch container yards.",
    });
  });
};

export const addContainerYard = (yard) => (dispatch) => {
  const { containerYardsRef } = firebase;
  dispatch({ type: EDIT_CONTAINER_YARD, payload: "Add" });
  const payload = buildContainerYardPayload(yard);
  return push(containerYardsRef, payload).then((result) => {
    const current = store.getState().containeryards.yards || [];
    if (!current.find((item) => item.id === result.key)) {
      dispatch({
        type: FETCH_CONTAINER_YARDS_SUCCESS,
        payload: [...current, { id: result.key, ...payload }]
      });
    }
    return result;
  }).catch((error) => {
    dispatch({
      type: FETCH_CONTAINER_YARDS_FAILED,
      payload: error && error.message ? error.message : "Unable to add container yard.",
    });
    throw error;
  });
};

export const updateContainerYard = (yard) => (dispatch) => {
  const { containerYardEditRef } = firebase;
  dispatch({ type: EDIT_CONTAINER_YARD, payload: "Update" });
  const payload = buildContainerYardPayload(yard);
  return set(containerYardEditRef(yard.id), payload).then(() => {
    const current = store.getState().containeryards.yards || [];
    dispatch({
      type: FETCH_CONTAINER_YARDS_SUCCESS,
      payload: current.map((item) => item.id === yard.id ? { id: yard.id, ...payload } : item)
    });
  }).catch((error) => {
    dispatch({
      type: FETCH_CONTAINER_YARDS_FAILED,
      payload: error && error.message ? error.message : "Unable to update container yard.",
    });
    throw error;
  });
};

export const deleteContainerYard = (yard) => (dispatch) => {
  const { containerYardEditRef } = firebase;
  dispatch({ type: EDIT_CONTAINER_YARD, payload: "Delete" });
  return remove(containerYardEditRef(yard.id)).then(() => {
    const current = store.getState().containeryards.yards || [];
    dispatch({
      type: FETCH_CONTAINER_YARDS_SUCCESS,
      payload: current.filter((item) => item.id !== yard.id)
    });
  }).catch((error) => {
    dispatch({
      type: FETCH_CONTAINER_YARDS_FAILED,
      payload: error && error.message ? error.message : "Unable to delete container yard.",
    });
    throw error;
  });
};
